{
  "version": 1,
  "asset_id": "158e22b8-c599-4f97-a5b3-3061898aa086",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/158e22b8-c599-4f97-a5b3-3061898aa086/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/158e22b8-c599-4f97-a5b3-3061898aa086/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.webp",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.webp",
  "size": 69214,
  "content_type": "image/webp",
  "created_at": "2026-08-27T15:20:41Z"
}
